import Connector, { takeQuery } from '../../agent';
import types from './types';

const Equipments = {
  getAssetEquipmentAutocompleteList: ({ prefixStr }) =>
    Connector.api.get(`/equipments/asset/autocomplete?prefixStr=${prefixStr}&equipmentClass=`),
  getPositionEquipmentAutocompleteList: ({ prefixStr }) =>
    Connector.api.get(`/equipments/position/autocomplete?prefixStr=${prefixStr}&equipmentClass=`),
  getEquipmentLevAutocompleteList: ({ prefixStr }) =>
    Connector.api.get(`/equipments/asset/autocomplete?prefixStr=${prefixStr}&equipmentClass=PLEV`),
};

const equipmentSagas = [
  takeQuery(
    types.GET_EQUIPMENT_ASSET_AUTOCOMPLETE_LIST,
    Equipments.getAssetEquipmentAutocompleteList
  ),
  takeQuery(
    types.GET_EQUIPMENT_POSITION_AUTOCOMPLETE_LIST,
    Equipments.getPositionEquipmentAutocompleteList
  ),
  takeQuery(types.GET_EQUIPMENT_LEV_AUTOCOMPLETE_LIST, Equipments.getEquipmentLevAutocompleteList),
];

export default equipmentSagas;
